import {inject, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
  name: 'transactionStatus',
  standalone: false,
})
export class TransactionStatusPipe implements PipeTransform {
  private readonly translate = inject(TranslateService);

  transform(value: unknown): string {
    return (
      this.translate.instant(`enums.transactionStatus.${value}`) ||
      this.translate.instant('common.unknown')
    );
  }
}
